import { placements as l } from "./index666.js";
import { ArrowDown as r, CircleClose as p } from "./index537.js";
import { defaultProps as i } from "./index678.js";
import { tagProps as t } from "./index679.js";
import { scrollbarEmits as n } from "./index671.js";
import { buildProps as f, definePropType as e } from "./index601.js";
import { useAriaProps as u } from "./index650.js";
import { useEmptyValuesProps as d } from "./index583.js";
import { useTooltipContentProps as o } from "./index680.js";
import { iconPropType as a } from "./index606.js";
import { useSizeProp as s } from "./index607.js";
const v = f({
  /**
   * @description the name attribute of select input
   */
  name: String,
  /**
   * @description native input id
   */
  id: String,
  /**
   * @description binding value
   */
  modelValue: {
    type: e([
      Array,
      String,
      Number,
      Boolean,
      Object
    ]),
    default: void 0
  },
  /**
   * @description the autocomplete attribute of select input
   */
  autocomplete: {
    type: String,
    default: "off"
  },
  /**
   * @description for non-filterable Select, this prop decides if the option menu pops up when the input is focused
   */
  automaticDropdown: Boolean,
  /**
   * @description size of Input
   */
  size: s,
  /**
   * @description tooltip theme, built-in theme: `dark` / `light`
   */
  effect: {
    type: e(String),
    default: "light"
  },
  /**
   * @description whether Select is disabled
   */
  disabled: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description whether select can be cleared
   */
  clearable: Boolean,
  /**
   * @description whether Select is filterable
   */
  filterable: Boolean,
  /**
   * @description whether creating new items is allowed. To use this, `filterable` must be true
   */
  allowCreate: Boolean,
  /**
   * @description whether Select is loading data from server
   */
  loading: Boolean,
  /**
   * @description custom class name for Select's dropdown
   */
  popperClass: {
    type: String,
    default: ""
  },
  /**
   * @description custom style for Select's dropdown
   */
  popperStyle: {
    type: e([String, Object])
  },
  /**
   * @description [popper.js](https://popper.js.org/docs/v2/) parameters
   */
  popperOptions: {
    type: e(Object),
    default: () => ({})
  },
  /**
   * @description whether options are loaded from server
   */
  remote: Boolean,
  /**
   * @description debounce delay during remote search, in milliseconds
   */
  debounce: {
    type: Number,
    default: 300
  },
  /**
   * @description displayed text while loading data from server, default is 'Loading'
   */
  loadingText: String,
  /**
   * @description displayed text when no data matches the filtering query, you can also use slot `empty`, default is 'No matching data'
   */
  noMatchText: String,
  /**
   * @description displayed text when there is no options, you can also use slot `empty`, default is 'No data'
   */
  noDataText: String,
  /**
   * @description function that gets called when the input value changes. Its parameter is the current input value. To use this, `filterable` must be true
   */
  remoteMethod: {
    type: e(Function)
  },
  /**
   * @description custom filter method, the first parameter is the current input value. To use this, `filterable` must be true
   */
  filterMethod: {
    type: e(Function)
  },
  /**
   * @description whether multiple-select is activated
   */
  multiple: Boolean,
  /**
   * @description maximum number of options user can select when `multiple` is `true`. No limit when set to 0
   */
  multipleLimit: {
    type: Number,
    default: 0
  },
  /**
   * @description placeholder, default is 'Select'
   */
  placeholder: {
    type: String
  },
  /**
   * @description select first matching option on enter key. Use with `filterable` or `remote`
   */
  defaultFirstOption: Boolean,
  /**
   * @description when `multiple` and `filter` is true, whether to reserve current keyword after selecting an option
   */
  reserveKeyword: {
    type: Boolean,
    default: !0
  },
  /**
   * @description unique identity key name for value, required when value is an object
   */
  valueKey: {
    type: String,
    default: "value"
  },
  /**
   * @description whether to collapse tags to a text when multiple selecting
   */
  collapseTags: Boolean,
  /**
   * @description whether show all selected tags when mouse hover text of collapse-tags. To use this, `collapse-tags` must be true
   */
  collapseTagsTooltip: Boolean,
  /**
   * @description the max tags number to be shown. To use this, `collapse-tags` must be true
   */
  maxCollapseTags: {
    type: Number,
    default: 1
  },
  /**
   * @description whether select dropdown is teleported, if `true` it will be teleported to where `append-to` sets
   */
  teleported: o.teleported,
  /**
   * @description when select dropdown is inactive and `persistent` is `false`, select dropdown will be destroyed
   */
  persistent: {
    type: Boolean,
    default: !0
  },
  /**
   * @description custom clear icon component
   */
  clearIcon: {
    type: a,
    default: p
  },
  /**
   * @description whether the width of the dropdown is the same as the input
   */
  fitInputWidth: Boolean,
  /**
   * @description custom suffix icon component
   */
  suffixIcon: {
    type: a,
    default: r
  },
  /**
   * @description tag type
   */
  tagType: { ...t.type, default: "info" },
  /**
   * @description tag effect
   */
  tagEffect: { ...t.effect, default: "light" },
  /**
   * @description whether to trigger form validation
   */
  validateEvent: {
    type: Boolean,
    default: !0
  },
  /**
   * @description in remote search method show suffix icon
   */
  remoteShowSuffix: Boolean,
  /**
   * @description determines whether the arrow is displayed
   */
  showArrow: {
    type: Boolean,
    default: !0
  },
  /**
   * @description offset of the dropdown
   */
  offset: {
    type: Number,
    default: 12
  },
  /**
   * @description position of dropdown
   */
  placement: {
    type: e(String),
    values: l,
    default: "bottom-start"
  },
  /**
   * @description list of possible positions for dropdown
   */
  fallbackPlacements: {
    type: e(Array),
    default: ["bottom-start", "top-start", "right", "left"]
  },
  /**
   * @description tabindex for input
   */
  tabindex: {
    type: [String, Number],
    default: 0
  },
  /**
   * @description which element the selection dropdown appends to
   */
  appendTo: o.appendTo,
  options: {
    type: e(Array)
  },
  props: {
    type: e(Object),
    default: () => i
  },
  ...d,
  ...u(["ariaLabel"])
});
n.scroll;
export {
  v as selectProps
};
